import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import { profileUrl } from '../../helpers/urlBuilder';

const onClick = (event) => {
    event.stopPropagation();
};

/**
 * Table cell represents stallion's Dam and Sire of the Dam
 *
 * @param {{}} props
 * @constructor
 */
const DamDamSireCell = props => (
    <span>
        {(() => {
            if (!props.rowData[props.customCell.options.damUid]) {
                return props.rowData[props.customCell.options.damName];
            }

            return (
                <a
                    href={profileUrl(
                'horse',
                props.rowData[props.customCell.options.damUid],
                props.rowData[props.customCell.options.damName]
            )}
                    className="js-popupLink ui-link ui-link_table"
                    onClick={onClick}
                >
                    {props.rowData[props.customCell.options.damName]}
                    <Svg
                        iconName="right"
                        size="XSmall"
                    />
                </a>
            );
        })()}
        <br />
        {(() => {
            if (!props.rowData[props.customCell.options.damSireUid]) {
                return props.rowData[props.customCell.options.damSireName];
            }

            return (
                <a
                    href={profileUrl(
                'horse',
                props.rowData[props.customCell.options.damSireUid],
                props.rowData[props.customCell.options.damSireName]
            )}
                    className="js-popupLink ui-link ui-link_table"
                    onClick={onClick}
                >
                    {props.rowData[props.customCell.options.damSireName]}
                    <Svg
                        iconName="right"
                        size="XSmall"
                    />
                </a>
            );
        })()}
    </span>
);

DamDamSireCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Name of current column
     */
    columnName: PropTypes.string.isRequired,
    /**
     * Custom cell component and options
     */
    customCell: PropTypes.object.isRequired
};

export default DamDamSireCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/DamDamSireCell.js